import React from "react";
import "./Service_pages.scss";
import img from "./services/Denture.png"; // Replace with your actual image path
import img2 from "./services/dental.png";
import { FaCheckCircle, FaTooth, FaThumbsUp, FaUserMd, FaHeart, FaShieldAlt, FaClinicMedical } from 'react-icons/fa';
import { MdOutlineStarPurple500, MdOutlineHealthAndSafety, MdOutlineVisibility, MdAccessibilityNew } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Dentures = () => {

    const types = [
        {
            title: "Complete Dentures",
            icon: <MdOutlineStarPurple500 />,
            desc: "Used when all teeth in a jaw are missing. These rest directly on the gums and restore the full appearance of your smile and chewing function.",
        },
        {
            title: "Partial Dentures",
            icon: <FaTooth />,
            desc: "Ideal when some natural teeth remain. These fill gaps using metal clasps or flexible connectors attached to your existing healthy teeth.",
        },
        {
            title: "Flexible Dentures",
            icon: <MdAccessibilityNew />,
            desc: "Made from softer, lightweight materials that adapt to the shape of your gums, offering superior comfort and a more natural feel.",
        },
        {
            title: "Implant-Supported",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Attached securely to dental implants in the jawbone. These provide maximum stability and prevent the appliance from moving while eating.",
        },
    ];

    const advantages = [
        {
            title: "Restored Chewing Ability",
            description: "Allows you to return to a balanced diet by enabling proper food breakdown and chewing.",
        },
        {
            title: "Improved Speech Clarity",
            description: "Missing teeth often cause slurring; dentures help restore proper tongue placement for clear pronunciation.",
        },
        {
            title: "Facial Muscle Support",
            description: "Prevents the 'sunken' appearance by supporting facial muscles and maintaining your natural face shape.",
        },
        {
            title: "Boosted Self-Confidence",
            description: "A complete, natural-looking smile improves comfort and confidence in social and professional settings.",
        },
        {
            title: "Cost-Effective Solution",
            description: "An affordable way to replace multiple missing teeth compared to other full-arch restorative options.",
        },
        {
            title: "Natural Aesthetics",
            description: "Modern materials allow us to match the exact shade and shape of your original teeth and gum tissue.",
        },
    ];

    const benefits = [
        {
            category: "Function",
            benefit: "Bite Restoration",
            description: "Redistributes biting forces evenly across the jaw, protecting remaining natural teeth from wear.",
        },
        {
            category: "Function",
            benefit: "Speech Improvement",
            description: "Provides the necessary structure for clear enunciation and confident communication.",
        },
        {
            category: "Aesthetics",
            benefit: "Facial Structure",
            description: "Fills out the lips and cheeks, preventing the premature aging look associated with tooth loss.",
        },
        {
            category: "Aesthetics",
            benefit: "Custom Shade Matching",
            description: "Each tooth in the denture is selected to match your age, skin tone, and previous tooth color.",
        },
        {
            category: "Health",
            benefit: "Jaw Support",
            description: "Reduces the strain on jaw joints and prevents existing teeth from shifting into empty gaps.",
        },
        {
            category: "Health",
            benefit: "Oral Hygiene",
            description: "Removable nature allows for thorough cleaning of both the prosthetic and the underlying gum tissue.",
        },
    ];

    const reasons = [
        {
            icon: <FaUserMd />,
            title: 'Experienced Prosthodontists',
            description: 'Our specialists are experts in designing dentures that fit perfectly and look completely natural.'
        },
        {
            icon: <MdOutlineVisibility />,
            title: 'Digital Precision',
            description: 'We use digital scanning and precision impressions to ensure a suction-fit that minimizes slipping.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'High-Quality Materials',
            description: 'We use premium acrylics and biocompatible flexible resins for durability and long-term comfort.'
        },
        {
            icon: <FaHeart />,
            title: 'Patient-Centric Adjustments',
            description: 'We provide multiple follow-up sittings to fine-tune the fit until you are 100% comfortable.'
        },
        {
            icon: <FaClinicMedical />,
            title: 'Comprehensive Aftercare',
            description: 'From cleaning instructions to relining services, we support you throughout your journey with dentures.'
        },
        {
            icon: <FaThumbsUp />,
            title: 'Top-Rated in HSR Layout',
            description: 'Trusted by hundreds of senior citizens and patients for reliable, high-quality denture solutions.'
        }
    ];

    return (
        <>
            <div className="service1-section">
                <Helmet>
                    <title>Custom Dentures in HSR Layout | Complete & Partial Dentures Bengaluru</title>
                    <meta
                        name="description"
                        content="Restore your smile and chewing ability with custom dentures at Kosmix Dental Clinic, HSR Layout. We offer complete, partial, and flexible denture solutions."
                    />
                    <link
                        rel="canonical"
                        href="https://www.kosmixdentalclinic.com/services/dentures-in-hsr-layout"
                    />
                </Helmet>

                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200">
                        Custom Dentures in HSR Layout, Bengaluru
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Custom Dental Dentures" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                Tooth loss can significantly impact your daily life, affecting your ability to eat comfortably, speak clearly, and smile confidently. <strong>Dentures</strong> are one of the most reliable and widely used solutions for replacing missing teeth and restoring natural function.
                            </p>
                            <p>
                                At Kosmix Dental Clinic, our experienced specialists carefully design dentures that match the natural shape, color, and alignment of your teeth. We focus on creating a comfortable fit that allows you to regain your quality of life.
                            </p>
                            <p>
                                Using advanced materials and precise fabrication techniques, we offer everything from traditional complete sets to modern, lightweight flexible dentures that blend seamlessly with your smile.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="content" data-aos="fade-up" data-aos-delay="300">
                    <SectionTitle title="What Are Dentures?" />
                    <div className="text_first">
                        <p>
                            Dentures are removable dental appliances designed to replace missing teeth and surrounding gum tissues. They are not just for aesthetics; they support facial muscles that weaken due to tooth loss and are made from high-quality acrylic resin or metal frameworks to provide lasting strength and comfort.
                        </p>
                    </div>
                </div>

                <section className="denture-guidance-hub" data-aos="fade-up">
                    <div className="content">
                        <SectionTitle title="Signs You Need Dentures" />
                        <p className="text_first">
                            Significant tooth loss or dental damage often requires prosthetic intervention. Watch for these signs:
                        </p>
                    </div>

                    <div className="guidance-list" data-aos="fade-up" data-aos-delay="100">
                        {[
                            "Multiple missing teeth affecting your appearance.",
                            "Severe difficulty in chewing even soft foods.",
                            "Visible changes in facial structure (sunken cheeks).",
                            "Remaining teeth that feel loose or are shifting.",
                            "Severe gum disease leading to inevitable tooth loss.",
                            "Teeth broken beyond the scope of crowns or bridges.",
                        ].map((item, i) => (
                            <div className="guidance-item" key={i}>
                                <FaCheckCircle className="guidance-icon" />
                                <span>{item}</span>
                            </div>
                        ))}
                    </div>

                    <div className="guidance-divider"></div>

                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Adjusting & Eating Tips" />
                        <p className="text_first">
                            It takes a short time for the mouth to adapt. Follow these clinical guidelines for a smooth transition:
                        </p>
                    </div>

                    <div className="guidance-list" data-aos="fade-up" data-aos-delay="100">
                        {[
                            { label: "Adjustment:", text: "Minor discomfort or saliva increase is normal for the first few days." },
                            { label: "Eating:", text: "Start with soft foods, cut into small pieces, and chew slowly on both sides." },
                            { label: "Speech:", text: "Practice reading aloud to help your tongue adapt to the new appliance." },
                            { label: "Progress:", text: "Most patients return to normal eating habits within 2-4 weeks." },
                        ].map((item, i) => (
                            <div className="guidance-item" key={i}>
                                <FaCheckCircle className="guidance-icon" />
                                <span><strong>{item.label}</strong> {item.text}</span>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="importance-section">
                    <div className="content">
                        <h2 className="section-title" data-aos="fade-up">Caring for Your Dentures</h2>
                        <p className="text_first" data-aos="fade-up" data-aos-delay="100">
                            Proper maintenance is essential for oral hygiene and the longevity of your prosthetic:
                        </p>
                    </div>

                    <div className="importance-cards-container">
                        {[
                            { title: "● Daily Brushing", desc: "Clean your dentures daily using a specialized soft-bristle denture brush." },
                            { title: "● Rinse After Meals", desc: "Always rinse your dentures after eating to remove food particles." },
                            { title: "● Nightly Rest", desc: "Remove dentures at night to allow gum tissues to breathe and recover." },
                            { title: "● Proper Soaking", desc: "Store dentures in a cleaning solution or plain water overnight to prevent drying." },
                            { title: "● Professional Checks", desc: "Maintain regular dental visits to check fit as your jawbone changes over time." },
                        ].map((item, index) => (
                            <div className="importance-card1" data-aos="fade-up" data-aos-delay={150 + index * 100} key={index}>
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="why-choose-us">
                    <div className="wrapper">
                        <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
                            <img src={img2} alt="Modern Prosthetic Care" />
                        </div>

                        <div className="text-side" data-aos="fade-up" data-aos-delay="300">
                            <h2>Modern Technology in Dentures</h2>
                            <p>
                                At <strong>Kosmix Dental Clinic</strong>, we move beyond traditional methods to provide dentures that fit better and feel more natural.
                            </p>

                            <div className="doctor-info" data-aos="fade-up" data-aos-delay="400">
                                <h3>High-Tech Fabrication</h3>
                                <div className="doctor">
                                    <span className="emoji">🖥️</span>
                                    <div>
                                        <h4>Digital Dental Scanning</h4>
                                        <p>Replaces messy traditional molds with high-precision digital impressions.</p>
                                    </div>
                                </div>
                                <div className="doctor">
                                    <span className="emoji">🔬</span>
                                    <div>
                                        <h4>Advanced Materials</h4>
                                        <p>Utilization of flexible resins and high-impact acrylics for better durability.</p>
                                    </div>
                                </div>
                            </div>

                            <p>
                                Even with dentures, gum health remains vital. Regular visits allow us to monitor your jawbone
                                changes and perform relining to keep your dentures secure.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="crown-types-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Our Denture Solutions" />
                        <p className="text_first">
                            Whether you have lost a few teeth or an entire set, we provide customized options to suit your needs.
                        </p>
                    </div>

                    <div className="crown-grid">
                        {types.map((item, idx) => (
                            <div className="crown-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                                <div className="icon">{item.icon}</div>
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="timeline-container" style={{ overflowX: 'hidden', padding: '0 1rem' }}>
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="The Denture Treatment Journey" />
                        <p className="text_first">
                            A carefully planned process to ensure a perfect fit and a natural smile:
                        </p>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">🩺</div>
                        <div className="timeline-content" data-step="1">
                            <h3>Initial Consultation</h3>
                            <p>Thorough examination of gums and jawbone to determine the most suitable type of denture.</p>
                        </div>
                    </div>

                    <div className="timeline-step" data-aos="fade-left">
                        <div className="timeline-icon">📏</div>
                        <div className="timeline-content" data-step="2">
                            <h3>Impressions & Scans</h3>
                            <p>Precise measurements and 3D digital scans are taken to ensure the appliance fits comfortably.</p>
                        </div>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">🔬</div>
                        <div className="timeline-content" data-step="3">
                            <h3>Design & Fabrication</h3>
                            <p>The lab crafts your dentures, matching the color and alignment to your facial structure.</p>
                        </div>
                    </div>

                    <div className="timeline-step" data-aos="fade-left">
                        <div className="timeline-icon">✨</div>
                        <div className="timeline-content" data-step="4">
                            <h3>Fitting & Adjustment</h3>
                            <p>Initial fitting where we check suction, bite alignment, and overall comfort.</p>
                        </div>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">✅</div>
                        <div className="timeline-content" data-step="5">
                            <h3>Follow-up Refinement</h3>
                            <p>Adjustment sessions to eliminate any sore spots and ensure long-term ease of use.</p>
                        </div>
                    </div>
                </section>

                <section className="advantages-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Key Advantages of Modern Dentures" />
                        <p className="text_first">
                            Dentures are a time-tested solution that has evolved significantly in comfort and appearance:
                        </p>
                    </div>

                    <div className="advantages-grid">
                        {advantages.map((item, index) => (
                            <div key={index} className="advantage-text-item" data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="title-wrapper">
                                    <FaCheckCircle className="advantage-icon" />
                                    <h3>{item.title}</h3>
                                </div>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="benefits-section" data-aos="fade-up">
                    <div className="benefits-wrapper">
                        <div className="content">
                            <h2 className="section-title">Comprehensive Analysis of Denture Benefits</h2>
                        </div>
                        <div className="table-responsive">
                            <table className="styled-table">
                                <thead>
                                    <tr>
                                        <th>Advantage Category</th>
                                        <th>Specific Benefit</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {benefits.map((item, index) => (
                                        <tr key={index}>
                                            <td className="category-cell">
                                                {index === 0 || item.category !== benefits[index - 1].category ? item.category : ""}
                                            </td>
                                            <td>{item.benefit}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                <section className="denture-info-hub" data-aos="fade-up">
                    <div className="content">
                        <SectionTitle title="Frequently Asked Questions & Key Facts" />
                    </div>

                    <div className="info-hub-grid">
                        <div className="faq-list" data-aos="fade-up" data-aos-delay="100">
                            <div className="faq-item">
                                <h4><FaCheckCircle className="faq-icon" /> How long do dentures last?</h4>
                                <p>Generally 5 to 10 years. Your jawbone changes over time, so they may need relining or replacement.</p>
                            </div>
                            <div className="faq-item">
                                <h4><FaCheckCircle className="faq-icon" /> Do I need to remove them at night?</h4>
                                <p>Yes, dentists recommend removing them to allow your gum tissues to rest and prevent infections.</p>
                            </div>
                            <div className="faq-item">
                                <h4><FaCheckCircle className="faq-icon" /> Can they look natural?</h4>
                                <p>Absolutely. Modern acrylics allow us to mimic the translucency of both teeth and gums perfectly.</p>
                            </div>
                        </div>

                        <div className="info-highlights" data-aos="fade-up" data-aos-delay="200">
                            <div className="highlight-block">
                                <span className="highlight-label">Adaptation</span>
                                <h3>2 – 4 Weeks</h3>
                                <p>Typical time to feel fully comfortable</p>
                                <ul>
                                    <li>Improved Bite</li>
                                    <li>Clearer Speech</li>
                                    <li>Natural Sensation</li>
                                </ul>
                            </div>

                            <div className="divider-line"></div>

                            <div className="highlight-block">
                                <span className="highlight-label">Protection</span>
                                <h3>Longevity</h3>
                                <p>Premium materials for lasting use</p>
                                <ul>
                                    <li>High-Impact Acrylic</li>
                                    <li>Stain Resistance</li>
                                    <li>Secure Suction Fit</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="why-kosmix-timeline">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Why Choose Kosmix Dental Clinic for Your Dentures?" />
                        <p className="text_first">
                            Our reputation in HSR Layout is built on combining clinical expertise with a focus on patient comfort:
                        </p>
                    </div>
                    <div className="timeline">
                        {reasons.map((reason, index) => (
                            <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                                <div className="timeline-icon">{reason.icon}</div>
                                <div className="timeline-content">
                                    <h3>{reason.title}</h3>
                                    <p style={{ display: window.innerWidth <= 768 ? 'none' : 'block' }}>
                                        {reason.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>
                            Regain Your Confident Smile <span>Today!</span>
                        </h2>
                        <p>
                            Tooth loss shouldn't stop you from enjoying life. Schedule your custom denture consultation at Kosmix Dental Clinic and restore your chewing ability and smile aesthetics.
                        </p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book Consultation Now</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default Dentures;